/**
 * Fetch the product's full details using the ajax api.
 * @param {string} productHandle
 */
export const getProduct = (productHandle) => {

  return new Promise((resolve, reject) => {

    fetch(`${window.Shopify.routes.root}products/${productHandle}.js`)
    .then((res)     => res.json())
    .then((product) => resolve(product))
    ;

  });

};

/**
 * Get the contents of the cart
 */
export const getCart = (callback, errorCallback) => {

  return new Promise((resolve, reject) => {

    const url = `${Shopify.routes.root}cart.js`;

    fetch(url)
    .then(res => res.json())
    .then((res) => {
      resolve(res);
    })
    .catch((err) => {
      console.warn("There was an error loading your cart contents", err);
      reject(err);
    });


  });

};

/**
 * Add the product to the cart using the Shopify Ajax API
 */
export const addToCart = (request) => {

  return new Promise((resolve, reject) => {

    fetch(`${Shopify.routes.root}cart/add.js`, {
      body: JSON.stringify(request),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
      },
      method: 'POST'
    })
    .then((res) => {
      resolve(res);
    })
    .catch((err) => {
      reject(err);
    });

  });

};
